import { createTheme, ThemeOptions } from "@mui/material";

// Utility function to create a custom MUI theme
function createMyTheme(options: ThemeOptions) {
    return createTheme({
        ...options,
    });
}

// Extend MuiTheme with custom properties
// Example code for a custom color integration into the material theme
declare module "@mui/material/styles/createTheme" {
    interface Theme {
        customColors: {
            normal: string;
            priority: string;
        };
    }
    // Allow configuration using `createMuiTheme`
    interface ThemeOptions {
        customColors?: {
            normal?: string;
            priority?: string;
        };
    }
}

/*********************************************************************
 *                          The dark theme
 ********************************************************************/

const baseTheme: ThemeOptions = {
    // shape: {
    //     borderRadius: 20
    // },
    palette: {
        primary: {
            main: "#14498C",
            light: "#14498C",
            dark: "#509af8",
            contrastText: "#FFF",
        },
        secondary: {
            main: "#6A0F8E",
            dark: "#6A0F8E",
            light: "#c648f8",
        },
        success: {
            main: "#6dc20c",
            light: "#a6fd42",
            dark: "#6dc20c",
        },
    },
    typography: {
        h1: {
            // fontSize: "6rem"
            fontSize: "2.5rem",
        },
        h2: {
            // fontSize: "3.75rem"
            fontSize: "2rem",
        },
        h3: {
            // fontSize: "3rem"
            fontSize: "1.75rem",
        },
        h4: {
            // fontSize: "2.125rem"
            fontSize: "1.5rem",
        },
        h5: {
            // fontSize: "1.5rem"
            fontSize: "1.25rem",
        },
        h6: {
            // fontSize: "1.25rem"
            fontSize: "1.125rem",
        },
    },
    components: {
        // MuiTypography: {
        //     styleOverrides: { h1: {
        //         fontSize: ""
        //         }}
        // },
        MuiCssBaseline: {
            // styleOverrides: `html {
            //     ::-webkit-scrollbar {
            //         width: 0.5em
            //     }
            //     ::-webkit-scrollbar-track {
            //         -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0);
            //     }
            //     ::-webkit-scrollbar-thumb {
            //         background-color: rgba(120,120,120,0.4);
            //         border-radius: 10px;
            //     }
            // }`,
        },
    },
};

export const darkTheme = createMyTheme({
    ...baseTheme,
    // Define primary and secondary color
    palette: {
        ...baseTheme.palette,
        mode: "dark",
    },

    // Example code for a global style override of a material ui components
    components: {
        ...baseTheme.components,
        // MuiLink: {
        //     styleOverrides: {
        //         root: {
        //             color: "#7daee1",
        //         },
        //     },
        // },
        MuiCssBaseline: {
            styleOverrides: `html {
                ::-webkit-scrollbar {
                    width: 0.5em
                }
                ::-webkit-scrollbar-track {
                    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0);
                }
                ::-webkit-scrollbar-thumb {
                    background-color: rgba(120,120,120,0.4);
                    border-radius: 10px;
                }
            }`,
        },
    },
});

/*********************************************************************
 *                          The light theme
 ********************************************************************/

export const lightTheme = createMyTheme({
    ...baseTheme,
    // Define primary and secondary color
    palette: {
        ...baseTheme.palette,
        mode: "light",
        background: {
            ...baseTheme.palette?.background,
            default: "#eeeeee",
        },
    },

    // // Example code for a custom color integration into the material theme
    // customColors: {
    //     normal: "#90e0a6",
    //     priority: "#fe7d6c",
    // },

    // Example code for a global style override of a material ui components
    components: {
        ...baseTheme.components,

        // MuiLink: {
        //     styleOverrides: {
        //         root: {
        //             color: "#356cb1",
        //         },
        //     },
        // },
        // MuiCssBaseline: {
        //     styleOverrides: `
        // html {
        //   ::-webkit-scrollbar {
        //     width: 0.5em
        //   }
        //   ::-webkit-scrollbar-track {
        //       -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0);
        //   }
        //   ::-webkit-scrollbar-thumb {
        //     background-color: rgba(0,0,0,0.4);
        //     border-radius: 10px;
        //   }
        // }
        // `,
        // },
    },
});
